import { DateFormats, formatDate } from '@strata/helper-functions';

export const formatInboundOrtfSourceLabel = (sendingPharmacyName, dateReceived) => {
    if (!sendingPharmacyName || !dateReceived) {
        return undefined;
    }

    return `${sendingPharmacyName}-${formatDate(dateReceived, DateFormats.DATE)}`;
};
